/*-----------------------------------------Dynamic logo------------------------------------------------------*/
export const dynamicLogo = () =>{
    $('.hp-logo.dynamic .hp-logo-base').mouseover(function () {
        $('.hp-logo-sub').removeClass('active');
        $('.hp-logo-postfix').addClass('active');
    });
    
    $('.hp-logo.dynamic .hp-logo-base').mouseleave(function () {
        $('.hp-logo-sub').addClass('active');
        $('.hp-logo-postfix').removeClass('active');
    });
};